// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"675":"9ec8b775","778":"18da90af"}[chunkId] + ".chunk.js";
};